import { render, staticRenderFns } from "./DealsList.vue?vue&type=template&id=18cd7230&scoped=true&"
import script from "./DealsList.vue?vue&type=script&lang=js&"
export * from "./DealsList.vue?vue&type=script&lang=js&"
import style0 from "./DealsList.vue?vue&type=style&index=0&id=18cd7230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd7230",
  null
  
)

export default component.exports